import { useMedia } from "react-use";

/**Has mouse, trackpad, stylus, trackball vs only finger (mobile) ... */
export function useHasFinePointer() {
	// Pointer: fine = mouse, trackball, stylus
	// useWatch will retrigger on change
	return useMedia("(pointer:fine)");
}
